<template>
    <div class="make-job-post">
        <div class="control-width mx-auto">
            <div class="p-4 p-md-5 border shadow-sm add-rounded">
                <h4 class="mb-3 font-weight-bold kova-text">Let's go ahead and make a job post for you</h4> 
                <h6 class="font-weight-bold mb-4 text-left">Write a detailed task description of what developer(s) will build</h6> 
                <a-input size="large" class="m-auto w-100" placeholder="Job description here" />
                <h6 class="font-weight-bold mb-4 mt-5 text-left">select skill(s) you require from your developer</h6>          

                <div class="d-flex flex-wrap text-left">
                    <div class="pl-4 py-1" style="min-width: 200px" v-for="skill in skills" :key="skill">
                        <label class="checkbox-label mb-3">
                            <input type="checkbox" :value="skill" v-model="devSkills"/>
                            <span class="checkbox-custom rectangular"></span><span class="mb-3 input-title ml-4 pl-2">{{skill}}</span>
                        </label>
                    </div>
                </div>            
                <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
                    <div class="row">
                        <div class="col text-left">
                            <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="goBack"> Back </button>
                        </div>
                        <div class="col text-right">
                            <router-link to="/onboarding-review">
                                <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded">Next </button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-right kova-text pt-3 mr-4 mb-5">
                <router-link to="/onboarding-review">
                    <span>Skip <font-awesome-icon icon="step-forward"></font-awesome-icon></span>
                </router-link>
            </div>
        </div>
        
        
 </div>
</template>
<script>
export default {
    name: 'make-job-post',
    data(){
        return {
            duration: '',
            showInput: false,
            skills: [
                'Android', 'IOS', 'CyberSecurity','Data Engineering', 'eCommerce', 'Web Application','Front-end',
                'Back-end', 'UI/UX', 'Artificial Intelligence', 'Blockchain', 'Integration', 'Project management',
                'DApps', 'DevOps'
            ],
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        },
        next(){
            this.$router.push('onboarding-review')
        },
        skip(){
            this.$router.push('onboarding-review')
        }
    }
}
</script>
<style scoped>
.control-width{
    width: 600px;
}
.input-title{
    font-size: 15px;
}
@media (min-width: 768px) and (max-width: 991px){
   
}
@media (max-width: 767px){
    .control-width{
        width:500px;
    }
}
@media (max-width: 550px){
    .control-width{
        width:98%;
    }
}
</style>